import styled from "styled-components";

export const Legend = styled.legend`
    margin-top: 41px;
    margin-bottom: 17px;
    color: #454546;
    font-size: 13px;
`;